import dlv from 'dlv';
import { ClaimUpdateRequest } from '../../../types/claim';
import {
	DisbursementCreateRequest,
	DisbursementRequest,
	DisbursementUpdateRequest,
} from '../../../types/disbursements';
import { DISBURSEMENT_SPECIAL_FIELDS } from '../data/constants';
import {
	DisbursementDirtyFields,
	DisbursementFormValues,
} from '../formBuilders/getDisbursementForm';
import { FormBuilder, FormShape } from '../types';
import {
	filterObjectByKeys,
	getPathsForForms,
	updateRequestBuilder,
} from '../utils';

export const disbursementUpdateBuilder = (
	dirtyFields: DisbursementDirtyFields,
	formValues: DisbursementFormValues,
	fields: FormShape<FormBuilder>,
	primaryFormName: string,
	timezone = 'America/Los_Angeles',
	cashBalanceLocator: string,
) => {
	const paths = getPathsForForms(fields, primaryFormName);
	let updateObject = {} as DisbursementUpdateRequest;
	paths.forEach((key) => {
		if (Object.keys(dlv(dirtyFields, key, {})).length > 0) {
			let newUpdatedObject;
			const currDirtyFields = { [key]: dlv(dirtyFields, key, {}) };
			const currFormValues = { [key]: dlv(formValues, key, {}) };
			const currFields = {
				[key]: dlv(fields, key, {}),
			} as FormShape<FormBuilder>;

			const amount = dlv(
				currFormValues,
				`${key}.${DISBURSEMENT_SPECIAL_FIELDS.amount}`,
				'',
			);

			if (dirtyFields['disbursement']['amount']) {
				updateObject.amount = amount;
			}

			const filteredCurrFormValues = {
				[key]: filterObjectByKeys(currFormValues[key], [
					DISBURSEMENT_SPECIAL_FIELDS.amount,
					DISBURSEMENT_SPECIAL_FIELDS.amountCurrency,
					DISBURSEMENT_SPECIAL_FIELDS.policyLocator,
					DISBURSEMENT_SPECIAL_FIELDS.policyholderLocator,
				]),
			};

			const filteredCurrDirtyFields = {
				[key]: filterObjectByKeys(currDirtyFields[key], [
					DISBURSEMENT_SPECIAL_FIELDS.amount,
					DISBURSEMENT_SPECIAL_FIELDS.amountCurrency,
					DISBURSEMENT_SPECIAL_FIELDS.policyLocator,
					DISBURSEMENT_SPECIAL_FIELDS.policyholderLocator,
				]),
			};

			newUpdatedObject = updateRequestBuilder<ClaimUpdateRequest>(
				filteredCurrDirtyFields,
				filteredCurrFormValues,
				currFields,
				key,
				timezone,
			);
			updateObject = { ...updateObject, ...newUpdatedObject };
		}
	});
	return updateObject;
};

export const disbursementCreateBuilder = (
	dirtyFields: DisbursementDirtyFields,
	formValues: DisbursementFormValues,
	fields: FormShape<FormBuilder>,
	primaryFormName: string,
	timezone = 'America/Los_Angeles',
	cashBalanceLocator: string,
) => {
	const paths = getPathsForForms(fields, primaryFormName);
	let updateObject = {} as DisbursementCreateRequest;
	let requestObj = {} as DisbursementRequest;
	paths.forEach((key) => {
		if (Object.keys(dlv(dirtyFields, key, {})).length > 0) {
			let newUpdatedObject;
			const currDirtyFields = { [key]: dlv(dirtyFields, key, {}) };
			const currFormValues = { [key]: dlv(formValues, key, {}) };
			const currFields = {
				[key]: dlv(fields, key, {}),
			} as FormShape<FormBuilder>;

			const amount = dlv(
				currFormValues,
				`${key}.${DISBURSEMENT_SPECIAL_FIELDS.amount}`,
				'',
			);

			updateObject.amount = amount;

			const filteredCurrFormValues = {
				[key]: filterObjectByKeys(currFormValues[key], [
					DISBURSEMENT_SPECIAL_FIELDS.amount,
					DISBURSEMENT_SPECIAL_FIELDS.amountCurrency,
					DISBURSEMENT_SPECIAL_FIELDS.policyLocator,
					DISBURSEMENT_SPECIAL_FIELDS.policyholderLocator,
				]),
			};

			const filteredCurrDirtyFields = {
				[key]: filterObjectByKeys(currDirtyFields[key], [
					DISBURSEMENT_SPECIAL_FIELDS.amount,
					DISBURSEMENT_SPECIAL_FIELDS.amountCurrency,
					DISBURSEMENT_SPECIAL_FIELDS.policyLocator,
					DISBURSEMENT_SPECIAL_FIELDS.policyholderLocator,
				]),
			};

			newUpdatedObject = updateRequestBuilder<ClaimUpdateRequest>(
				filteredCurrDirtyFields,
				filteredCurrFormValues,
				currFields,
				key,
				timezone,
			);
			updateObject = { ...updateObject, ...newUpdatedObject };
			requestObj.request = updateObject as DisbursementCreateRequest;
			requestObj.locator = cashBalanceLocator;
		}
	});
	return requestObj;
};
